const SHOWS_ADMIN = 'showsAdmin';
const SHOWS_OWNER = 'admin';
const MANAGE_OWN_SHOWS = 'manageOwnShows';
const HOST = 'host';
const MODERATOR = 'moderator';
const SHOW_CREATOR = 'showCreator';

const CALLS_OWNER = 'callsAdmin';
const CALLS_MANAGER = 'callsManager';
const CALLS_DEVELOPER = 'callsDeveloper';
const CALLS_USER_ADMIN = 'callsUserAdmin';
const CALLS_AGENT = 'callsAgent';

const CLIENT_OWNER = 'clientOwner';

const VOD_OWNER = 'vodOwner';

const CHAT_OWNER = 'chatOwner';
const CHAT_AGENT = 'chatAgent';

const ONE_TO_MANY_ROLES = {
  SHOWS_OWNER,
  SHOWS_ADMIN,
  HOST,
  MODERATOR,
  SHOW_CREATOR,
  MANAGE_OWN_SHOWS,
};

const ONE_TO_ONE_ROLES = {
  CALLS_OWNER,
  CALLS_MANAGER,
  CALLS_DEVELOPER,
  CALLS_USER_ADMIN,
  CALLS_AGENT,
};


const CLIENT_ROLES = {
  CLIENT_OWNER,
};

const VOD_ROLES = {
  VOD_OWNER,
};

const CHAT_ROLES = {
  CHAT_OWNER,
  CHAT_AGENT,
};

module.exports = {
  ONE_TO_MANY_ROLES,
  ONE_TO_ONE_ROLES,
  CLIENT_ROLES,
  VOD_ROLES,
  CHAT_ROLES,
};
